// extracted by mini-css-extract-plugin
export var card = "_q8-0";
export var content = "_q8-2";
export var details = "_q8-3";
export var icon = "_q8-1";
export var iconBlue = "_q8-5";
export var iconBrand = "_q8-4";
export var iconGrayBlue = "_q8-6";
export var iconGreen = "_q8-7";
export var iconIndigo = "_q8-8";
export var iconOrange = "_q8-9";
export var iconPurple = "_q8-a";
export var iconRed = "_q8-b";
export var iconWarning = "_q8-c";